import { render } from "./AskedSection.vue?vue&type=template&id=45aa889a"
import script from "./AskedSection.vue?vue&type=script&lang=js"
export * from "./AskedSection.vue?vue&type=script&lang=js"

import "./AskedSection.vue?vue&type=style&index=0&id=45aa889a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__